export enum TransactionType {
  ExtraBooking = 1,
  Cost = 2,
  BuyTransactionTrading = 4,
  Collection = 6,
  FailedCollection = 7,
  CollectionCostReversal = 8,
  IncomingInsurance = 11,
  DisbursementManualWithdrawal = 12,
  SellTransactionTrading = 13,
  InternalTransferTarget = 14,
  InternalTransferSource = 15,
  InternalTransferCostCorrection = 16,
  SellTransactionManualWithdrawal = 17,
  SellTransactionInternalTransfer = 18,
  DisbursementPeriodic = 19,
  DisbursementAccountClosure = 20,
  SellTransactionAccountClosure = 21,
  ManualCostAccountClosure = 22,
  SellTransactionCollectingProduct = 23,
  RetryFailedCollection = 24,
  GeneralAccountCorrection = 25,
  DebetCorrection = 26,
  Legacy = 27,
  IdentificationBooking = 28,
}
